import LegalLayout from "@/components/LegalLayout";
import Seo from "@/components/Seo";

export const Impressum = () => {
  return (
    <LegalLayout title="Impressum" updated="01.08.2026">
      <Seo
        title="Impressum – Kurpfalz Automation"
        description="Impressum von Kurpfalz Automation (ck-partners), Christian Knapp, Oberdorfstr. 25, 68542 Heddesheim."
        path="/impressum"
      />
      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Angaben gemäß § 5 DDG</h2>
        <p className="mt-2">
          Christian Knapp<br />
          ck-partners (Einzelunternehmen / Kleingewerbe)<br />
          Marke: Kurpfalz Automation, eine Marke von ck-partners<br />
          Oberdorfstr. 25<br />
          68542 Heddesheim<br />
          Deutschland
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Kontakt</h2>
        <p className="mt-2">
          E-Mail: <a className="underline hover:text-[#16273F]" href="mailto:ck-partners@gmx.net">ck-partners@gmx.net</a><br />
          WhatsApp/Telefon: <a className="underline hover:text-[#16273F]" href="https://wa.me/4915233560557">+49 152 33560557</a>
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Steuerliche Angaben</h2>
        <p className="mt-2">
          Steuernummer: auf Anfrage.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p className="mt-2">Christian Knapp (Anschrift wie oben)</p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Haftung für Inhalte</h2>
        <p className="mt-2">
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
          Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine
          rechtswidrige Tätigkeit hinweisen.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Haftung für Links</h2>
        <p className="mt-2">
          Unser Angebot enthält gegebenenfalls Links zu externen Websites
          Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können
          wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die
          Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
          Betreiber der Seiten verantwortlich.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Urheberrecht</h2>
        <p className="mt-2">
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf
          diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge
          Dritter sind als solche gekennzeichnet.
        </p>
      </section>

      <section>
        <h2 className="font-semibold text-lg text-[#16273F]">Streitschlichtung</h2>
        <p className="mt-2">
          Wir sind gemäß § 36 Verbraucherstreitbeilegungsgesetz (VSBG) nicht
          verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>
    </LegalLayout>
  );
};

export default Impressum;
